// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
/**
 * Creates an enum style object for the OTelSpanKind enum, providing the enum
 * values as properties of the object as both string and number types.
 * This allows for easy access to the enum values in a more readable format.
 */
export var OTelSpanKind = (/*@__PURE__*/createEnumStyle({
    INTERNAL: 0 /* eOTelSpanKind.INTERNAL */,
    SERVER: 1 /* eOTelSpanKind.SERVER */,
    CLIENT: 2 /* eOTelSpanKind.CLIENT */,
    PRODUCER: 3 /* eOTelSpanKind.PRODUCER */,
    CONSUMER: 4 /* eOTelSpanKind.CONSUMER */
}));
//# sourceMappingURL=OTelSpanKind.js.map